import React from 'react'
import cl from 'classnames'

import { Props } from './types'

import styles from './styles.module.scss'

const sizeMap = {
	xl: styles.xlarge,
	l: styles.large,
	m: styles.medium,
	s: styles.small
}

export const typeMap = {
	disabled: styles.disabled,
	default: styles.default,
	green: styles.green,
	blue: styles.blue,
	red: styles.red,
	lightRed: styles.lightRed,
	violet: styles.violet,
	purple: styles.purple,
	orange: styles.orange,
	grey: styles.grey,
	blueMain: styles.blueMain
}

const Tag: React.FC<Props> = ({
	children,
	className,
	size = 'l',
	type = 'default',
	isSingle = true,
	isTableElem = false
}) => {
	return (
		<span
			className={cl(
				styles.tag,
				className,
				sizeMap[size],
				typeMap[type],
				{ [styles.noMargin]: isSingle },
				{ [styles.tableElem]: isTableElem }
			)}
		>
			{children}
		</span>
	)
}

export const InlineTag: React.FC<Props> = ({ children, ...props }) => (
	<Tag {...props} isSingle={false}>
		{children}
	</Tag>
)

export default Tag
